// @core/api/endpoints/affiliate/change_affiliate_tier.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AffiliateResponse,
  ChangeAffiliateTierRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Change affiliate tier
 * Performs change operation on affiliate tier.
 */
export async function ChangeAffiliateTier(
  affiliate_id: string,
  data: ChangeAffiliateTierRequest,
  options?: RequestOptions
): Promise<AffiliateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/affiliates/:affiliate_id/tier`;
  requestPath = requestPath.replace(':affiliate_id', encodeURIComponent(affiliate_id));
  const requestOptions = options;
  return client.post<AffiliateResponse>(requestPath, data, requestOptions);
}
